import { AxiosRequestConfig } from 'axios';
import axios from './axios';
// HTTP 只处理 status是200的响应，res是response data
export type Response<T> =
  | {
      success: true;
      code: string;
      message: string;
      data: T;
    }
  | { success: false; data: null; code: string; message: string };
class HTTP {
  config: AxiosRequestConfig = {
    baseURL: axios.defaults.baseURL
  };
  private handlerError() {
    try {
    } catch (e) {
      console.log(e);
    }
  }
  private getConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
    return Object.assign({}, this.config, config || {});
  }
  protected async get<T = any>(url: string, config?: AxiosRequestConfig) {
    const res: Response<T> = await axios.get(url, this.getConfig(config));
    return res;
  }
  protected async queryGet<T = any>(url: string, query: any = {}, config?: AxiosRequestConfig) {
    let _char = url.includes('?') ? '&' : '?';
    let _url = url + _char + objToUrl(query);
    const res: Response<T> = await axios.get(_url, this.getConfig(config));
    return res;
  }
  protected async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig) {
    const res: Response<T> = await axios.post(url, data, this.getConfig(config));
    return res;
  }
  protected async delete(url: string, config?: AxiosRequestConfig) {
    const res: Response<any> = await axios.delete(url, this.getConfig(config));
    return res;
  }
  protected async put(url: string, data?: any, config?: AxiosRequestConfig) {
    const res: Response<any> = await axios.put(url, data, this.getConfig(config));
    return res;
  }
  protected async patch(url: string, data?: any, config?: AxiosRequestConfig) {
    const res = await axios.patch(url, data, config);
    return res;
  }
  protected async request(config: AxiosRequestConfig) {
    const res = await axios.request(config);
    return res;
  }
  protected async head(url: string, config?: AxiosRequestConfig) {
    const res = await axios.head(url, config);
    return res;
  }
  protected async options(url: string, config?: AxiosRequestConfig) {
    const res = await axios.options(url, config);
    return res;
  }
}

const objToUrl = (obj: any) => {
  let arr = [];
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      arr.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]));
    }
  }
  return arr.join('&');
};
export default HTTP;
